// deps
import React, { memo } from "react";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TOING_SAVINGS_BANNER_TEST_IDS } from "@swiggy-private/cart-test-ids";

// styles
import { SavingsBannerWrapper } from "./styled";

const NewSavingsBanner = ({ title }: { title: string }) => {
    return (
        <SavingsBannerWrapper data-testid={TOING_SAVINGS_BANNER_TEST_IDS.WRAPPER}>
            <Text variant="V2.caption.neutral.bold" color="text_inverse_Med_Emphasis">
                {title}
            </Text>
        </SavingsBannerWrapper>
    );
};

export default memo(NewSavingsBanner);
